import React from "react";
import Select from "react-select";
import styled from "styled-components";
import H5 from "components/H5.js";
import i18next from "i18next";

const CurrencyFilter = ({ availableCurrencies, selectedCurrency, onSelect, className }) => {
  if (!availableCurrencies || availableCurrencies.size <= 1) return null;

  const options = availableCurrencies.map(currency => ({ value: currency, label: currency })).toJS();
  const value = options.find(opt => opt.value === selectedCurrency) || options[0];

  return (
    <div className={className}>
      <H5>{i18next.t("sidebar.currency", { defaultValue: "Currency" })}</H5>
      <span className="filter-item">
        <Select
          value={value}
          options={options}
          onChange={opt => onSelect(opt.value)}
          theme={theme => ({ ...theme, borderRadius: 0 })}
          placeholder={i18next.t("select.default")}
          noOptionsMessage={() => i18next.t("select.noOptions")}
        />
      </span>
    </div>
  );
};

const StyledCurrencyFilter = styled(CurrencyFilter)`
  margin: 0 0 8px;

  > details {
    &:focus {
      outline: none;
    }

    .filter-item {
      border: 1px solid #e5e5e5;
      border-top: 0 none;
      padding: 10px;
    }
  }
`;

export default React.memo(StyledCurrencyFilter);
